/* Arco di carte scorribile — motore, in JavaScript normale.
   Porta del widget D di sitocarte (VentaglioScorribile.jsx, React + GSAP).

   Perche' senza GSAP: nel sorgente si usavano solo gsap.set e gsap.to su
   x, y, rotation, scale, opacity, zIndex. Niente Draggable, niente timeline.
   Sono pose e transizioni, e le fa il CSS. Cosi' nel tema non entra nessuna
   libreria esterna — il contrario delle sezioni comprate, che si portano
   dietro tre copie di Swiper.

   ⚠️ Una differenza dichiarata: l'attenuazione originale e'
   elastic.out(1,.75), che rimbalza piu volte. Un cubic-bezier CSS sa fare una
   sola sporgenza (--molla in arco-carte.css). Il gesto e' lo stesso, il
   rimbalzo e' piu corto. */

(function () {
  'use strict';

  /* VISIBILI e META descrivono la GEOMETRIA dell'arco: i sette posti della
     tavola POSTI qui sotto. Quante carte stiano davvero in scena e' un'altra
     cosa e si decide per sezione (vedi INSCENA dentro avvia): con sette carte
     sole e sette posti non avanza niente fuori scena, e il giro dell'arco si
     vedrebbe saltare da un capo all'altro. */
  var VISIBILI = 7;
  var META = 3;

  /* posizione, rotazione e scala di ogni posto dell'arco.
     x e y in frazioni della LARGHEZZA della carta: e' cosi' che l'arco resta
     identico fra Poker (rapporto 1.43) e Trevisane (1.96). */
  var POSTI = [
    { giro: -21, scala: 0.776, x: -1.36, y: 0.33, z: 1 },
    { giro: -14, scala: 0.85,  x: -1.0,  y: 0.18, z: 2 },
    { giro: -7,  scala: 0.935, x: -0.5,  y: 0.06, z: 3 },
    { giro: 0,   scala: 1.0,   x: 0,     y: 0,    z: 10 },
    { giro: 7,   scala: 0.935, x: 0.5,   y: 0.06, z: 3 },
    { giro: 14,  scala: 0.85,  x: 1.0,   y: 0.18, z: 2 },
    { giro: 21,  scala: 0.776, x: 1.36,  y: 0.33, z: 1 }
  ];

  /* Con meno carte dei sette posti NON si spalmano sugli estremi: si prende il
     tratto centrale della stessa curva, centrato. Con due carte (Napoletane)
     normalizzando a ±1 una finiva al centro e l'altra 1,36 larghezze piu in la:
     due carte scordate sul tavolo, non un ventaglio. */
  function postoRidotto(quante, posto) {
    if (quante >= VISIBILI) return POSTI[posto];
    var scostamento = posto - (quante - 1) / 2;
    var indice = META + scostamento;
    var sotto = Math.max(0, Math.floor(indice));
    var sopra = Math.min(VISIBILI - 1, Math.ceil(indice));
    var frazione = indice - sotto;
    var a = POSTI[sotto], b = POSTI[sopra];
    var fra = function (k) { return a[k] + (b[k] - a[k]) * frazione; };
    return {
      giro: fra('giro'), scala: fra('scala'), x: fra('x'), y: fra('y'),
      z: 10 - Math.round(Math.abs(scostamento) * 2)
    };
  }

  function avvia(radice) {
    var dati;
    try { dati = JSON.parse(radice.querySelector('[data-arco-dati]').textContent); }
    catch (e) { return; }

    var scena = radice.querySelector('.arco__scena');
    var pallini = radice.querySelector('.arco__pallini');
    var avviso = radice.querySelector('[data-avviso]');
    var comandi = radice.querySelector('.arco__comandi');
    if (!scena) return;

    var menoMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var conMouse = window.matchMedia('(hover: hover)').matches;

    /* Quanti posti si usano davvero. Ne devono restare almeno un paio FUORI
       scena, se no scorrendo si vede una carta teletrasportarsi dall'ultimo
       posto al primo. Con i tre mazzi (10 carte) sono 7; con le sette carte
       personalizzate sono 5, e le due che avanzano fanno da riserva. */
    var INSCENA = dati.inScena || VISIBILI;
    var METAS = INSCENA >> 1;

    var mazzoId = dati.mazzoIniziale;
    var paletteId = dati.paletteIniziale;
    var carte = [];
    var retro = null;
    var elementi = [];
    var centro = 0;
    var totale = 0;
    var veri = 0;
    var scorre = false;
    var inMovimento = false;
    var largoCarta = 0;
    var sopraAttivo = null;
    var ritardoUscita = null;
    var entrando = false;
    var fineEntrata = null;
    var gettonePalette = 0;

    /* La larghezza vera si legge con offsetWidth, MAI con
       getBoundingClientRect(): quello include le trasformazioni, quindi con la
       carta gia scalata la misura usciva ridotta e l'arco si accartocciava. */
    function misura() {
      if (!elementi.length) return;
      var w = elementi[0].offsetWidth;
      if (w) {
        largoCarta = w;
        scena.style.setProperty('--largo-carta', w + 'px');
      }
    }

    function mappaVisibili(c) {
      var m = {};
      if (!scorre) { for (var i = 0; i < totale; i++) m[i] = i; return m; }
      for (var posto = 0; posto < INSCENA; posto++) {
        m[((c + posto - METAS) % totale + totale) % totale] = posto;
      }
      return m;
    }

    function posa(el, p, opaca) {
      el.style.setProperty('--x', p.x);
      el.style.setProperty('--y', p.y);
      el.style.setProperty('--giro', p.giro + 'deg');
      el.style.setProperty('--scala', p.scala);
      el.style.zIndex = p.z;
      el.classList.toggle('arco__carta--fuori', !opaca);
    }

    /* Scostamento al passaggio del mouse. La spinta e' smorzata rispetto
       all'originale del riferimento: li le carte erano piccole dentro un
       riquadro fisso, qui sono grandi e la centrale schizzava via. */
    function ridisponi(sopra) {
      var quanti = scorre ? INSCENA : totale;
      var visibili = mappaVisibili(centro);
      var postoCentrale = (scorre ? INSCENA : totale) >> 1;

      elementi.forEach(function (el, i) {
        var p = visibili[i];
        if (p === undefined) { posa(el, { x: 0, y: 0, giro: 0, scala: .5, z: 0 }, false); return; }
        var base = postoRidotto(quanti, p);
        var x = base.x, y = base.y, giro = base.giro, scala = base.scala;

        if (sopra !== null && sopra !== undefined) {
          var distanza = Math.abs(p - sopra);
          if (p === sopra) {
            y -= 0.12;
            scala *= 1.06;
          } else {
            var norm = postoCentrale > 0 ? (p - postoCentrale) / postoCentrale : 0;
            var spinta = 0.14 * (1 - Math.abs(norm)) * (1 + 0.15 * Math.max(0, 3 - distanza));
            if (p < sopra) { x -= spinta; giro -= 3 / (distanza + 1); }
            else { x += spinta; giro += 3 / (distanza + 1); }
          }
          el.style.transitionDelay = (distanza * 0.02) + 's';
        } else if (entrando) {
          /* stessi ritardi del sorgente: 0,15s piu 0,06s per posto, cosi le
             carte si aprono a ventaglio una dopo l'altra, non tutte insieme */
          el.style.transitionDelay = (0.15 + p * 0.06) + 's';
        } else {
          el.style.transitionDelay = (Math.abs(p - postoCentrale) * 0.02) + 's';
        }
        posa(el, { x: x, y: y, giro: giro, scala: scala, z: base.z }, true);
      });
    }

    function segnaPallini() {
      if (!pallini) return;
      Array.prototype.forEach.call(pallini.children, function (s, i) {
        s.classList.toggle('arco__pallino--attivo', i === centro % veri);
      });
    }

    function girabile() {
      var visibili = mappaVisibili(centro);
      elementi.forEach(function (el, i) {
        var e = (i === centro) && !!retro;
        el.classList.toggle('arco__carta--girabile', e);
        el.classList.remove('arco__carta--girata');

        /* Il dorso sta SOLO sulla carta centrale: e' l'unica che gira, e dieci
           immagini in piu' con la loro ombra sono dieci livelli in piu' da
           comporre, che sul telefono si pagano. Segue il posto centrale mentre
           l'arco scorre, perche' il giro appartiene al POSTO, non alla carta. */
        var dietro = el.querySelector('.arco__faccia--retro');
        if (e && !dietro) {
          dietro = document.createElement('img');
          dietro.className = 'arco__faccia arco__faccia--retro';
          dietro.src = retroDi(i);
          dietro.alt = '';
          dietro.decoding = 'async';
          el.querySelector('.arco__giro').appendChild(dietro);
        } else if (!e && dietro) {
          dietro.remove();
        }
        if (e) {
          el.setAttribute('role', 'button');
          el.setAttribute('tabindex', '0');
          el.setAttribute('aria-pressed', 'false');
          el.setAttribute('aria-label', (el.dataset.descrizione || 'Carta') + '. Gira e mostra il dorso');
        } else {
          el.removeAttribute('role');
          el.removeAttribute('tabindex');
          el.removeAttribute('aria-pressed');
          el.removeAttribute('aria-label');
        }
      });
      void visibili;
    }

    function scorri(verso) {
      if (inMovimento || !scorre) return;
      inMovimento = true;
      centro = verso === 'destra' ? (centro + 1) % totale : (centro - 1 + totale) % totale;
      girabile();
      segnaPallini();
      ridisponi(null);
      /* Rete di sicurezza: se il ciclo di disegno e fermo (scheda in secondo
         piano) transitionend non arriva mai e frecce e trascinamento
         resterebbero morti per sempre. */
      setTimeout(function () { inMovimento = false; }, menoMovimento ? 0 : 620);
    }

    function immagine(mazzo, palette, nome) {
      if (dati.modo === 'shopify') {
        return dati.base + 'carta-' + mazzo + '-' + palette.replace('palette-', 'p') + '-' + nome + '.webp' +
          (dati.versione ? '?v=' + dati.versione : '');
      }
      return dati.base + mazzo + '/' + palette + '/' + nome + '.webp';
    }

    /* Nel ventaglio misto ogni carta e' di una palette diversa, quindi il suo
       dorso e' diverso: `dorsi` dice, carta per carta, quale file usare. Dove
       non c'e' vale il dorso unico della palette scelta. */
    function retroDi(i) {
      if (!retro) return null;
      var d = dati.dorsi && dati.dorsi[carte[i]];
      return d ? immagine(mazzoId, paletteId, d) : retro;
    }

    function costruisci(anima) {
      var m = dati.mazzi[mazzoId];
      var nomi = (m.carte[paletteId] || m.carte[Object.keys(m.carte)[0]] || []);
      carte = nomi;
      veri = nomi.length;
      /* ⚠ Con tante carte quanti posti (le sette Trevisane personalizzate su
         sette posti) non resta nessuna riserva, e senza riserva l'arco non
         scorre: sparivano le frecce. Si ripete l'elenco, cosi' la riserva c'e'
         e il giro continua con le stesse carte. I pallini restano uno per
         carta VERA (`veri`), non per copia. */
      if (veri >= INSCENA && veri < INSCENA + 2) carte = nomi.concat(nomi);
      totale = carte.length;
      scorre = totale > INSCENA;
      centro = scorre ? METAS : totale >> 1;
      retro = m.retro.indexOf(paletteId) === -1 ? null : immagine(mazzoId, paletteId, 'back');

      scena.style.setProperty('--rapporto-carta', m.rapporto);
      scena.innerHTML = '';
      elementi = [];

      carte.forEach(function (nome, i) {
        var carta = document.createElement('div');
        carta.className = 'arco__carta';
        carta.dataset.descrizione = nome.replace('-', ' di ') + ', carta illustrata a mano';
        var giro = document.createElement('div');
        giro.className = 'arco__giro';
        var fronte = document.createElement('img');
        fronte.className = 'arco__faccia arco__faccia--fronte';
        fronte.src = immagine(mazzoId, paletteId, nome);
        fronte.alt = carta.dataset.descrizione;
        fronte.loading = i < INSCENA ? 'eager' : 'lazy';
        fronte.decoding = 'async';
        giro.appendChild(fronte);
        carta.appendChild(giro);
        /* Nasce GIA' nella posa di partenza dell'ingresso, invisibile: apri()
           aspetta fino a 0,9s che la prima immagine arrivi, e la prima volta
           che si apre un mazzo (immagini non ancora in memoria) le carte senza
           posa restavano visibili tutte impilate al centro per quel tempo. */
        posa(carta, { x: 0, y: 0.8, giro: 0, scala: 0.5, z: 0 }, false);
        scena.appendChild(carta);
        elementi.push(carta);
      });

      if (pallini) {
        pallini.innerHTML = '';
        nomi.forEach(function () {
          var s = document.createElement('span');
          s.className = 'arco__pallino';
          pallini.appendChild(s);
        });
      }
      if (comandi) comandi.hidden = !scorre;

      if (avviso) avviso.setAttribute('data-mostra', m.inArrivo ? '1' : '0');

      girabile();
      segnaPallini();
      apri(anima !== false);
    }

    /* L'INGRESSO DEL VENTAGLIO.
       Il guizzo non era colpa dell'animazione: era colpa della posa di
       PARTENZA. Le carte appena create non hanno --x, --y, --scala, quindi
       valgono i default — tutte impilate al centro a scala 1 — e la transizione
       partiva da li. Sulla centrale, che al centro ci resta, si vedeva solo un
       cambio di scala: il guizzo. Spegnere le transizioni toglieva il guizzo,
       ma anche l'ingresso, che e' la cosa bella.
       Cura giusta: si scrive a mano la posa di partenza del sorgente
       (impilate, piu in basso, meta scala, invisibili) a transizioni spente, si
       forza il ricalcolo, e POI si anima verso l'arco. */
    function apri(anima) {
      if (fineEntrata) { clearTimeout(fineEntrata); fineEntrata = null; }

      var parti = function () {
        misura();
        radice.classList.add('arco--muto');
        elementi.forEach(function (el) {
          el.style.transitionDelay = '0s';
          posa(el, { x: 0, y: 0.8, giro: 0, scala: 0.5, z: 0 }, false);
        });
        void scena.offsetHeight;   // costringe il browser a prendere per buona la posa di partenza
        radice.classList.remove('arco--muto');

        if (menoMovimento || !anima) { ridisponi(null); return; }

        radice.classList.add('arco--entrata');
        entrando = true;
        ridisponi(null);
        fineEntrata = setTimeout(function () {
          entrando = false;
          radice.classList.remove('arco--entrata');
          elementi.forEach(function (el) { el.style.transitionDelay = '0s'; });
        }, 1500);
      };

      /* Si aspetta che la PRIMA immagine sia decodificata: prima di allora
         --largo-carta e ancora quello del mazzo precedente, e i rapporti sono
         diversi (1,96 contro 1,43). Col tetto, se l'immagine non arrivasse. */
      var prima = elementi[0] && elementi[0].querySelector('img');
      if (!prima || prima.complete) { parti(); return; }
      var partito = false;
      var unaVolta = function () { if (!partito) { partito = true; parti(); } };
      prima.addEventListener('load', unaVolta, { once: true });
      prima.addEventListener('error', unaVolta, { once: true });
      setTimeout(unaVolta, 900);
    }

    /* --- gesti ----------------------------------------------------------- */
    scena.addEventListener('click', function (e) {
      var carta = e.target.closest('.arco__carta--girabile');
      if (!carta || !retro || inMovimento) return;
      var girata = carta.classList.toggle('arco__carta--girata');
      carta.setAttribute('aria-pressed', String(girata));
      carta.setAttribute('aria-label', (carta.dataset.descrizione || 'Carta') + '. ' +
        (girata ? 'Mostra il fronte' : 'Gira e mostra il dorso'));
    });

    scena.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var carta = e.target.closest('.arco__carta--girabile');
      if (!carta) return;
      e.preventDefault();
      carta.click();
    });

    /* Trascinamento orizzontale sul telefono. Ascoltatori passivi che non
       annullano il gesto: lo scorrimento verticale della pagina resta intatto,
       e si reagisce solo quando il movimento e chiaramente orizzontale. */
    var partenzaX = null, partenzaY = null;
    var SOGLIA = 40;
    scena.addEventListener('touchstart', function (e) {
      partenzaX = e.touches[0].clientX;
      partenzaY = e.touches[0].clientY;
    }, { passive: true });
    scena.addEventListener('touchend', function (e) {
      if (partenzaX === null) return;
      var dx = e.changedTouches[0].clientX - partenzaX;
      var dy = e.changedTouches[0].clientY - partenzaY;
      partenzaX = null;
      if (Math.abs(dx) > SOGLIA && Math.abs(dx) > Math.abs(dy)) {
        scorri(dx < 0 ? 'destra' : 'sinistra');
      }
    }, { passive: true });

    if (conMouse) {
      scena.addEventListener('mouseover', function (e) {
        var carta = e.target.closest('.arco__carta');
        if (!carta || inMovimento) return;
        if (ritardoUscita) { clearTimeout(ritardoUscita); ritardoUscita = null; }
        var visibili = mappaVisibili(centro);
        var p = visibili[elementi.indexOf(carta)];
        if (p !== undefined && p !== sopraAttivo) { sopraAttivo = p; ridisponi(p); }
      });
      scena.addEventListener('mouseleave', function () {
        if (inMovimento) return;
        if (ritardoUscita) clearTimeout(ritardoUscita);
        ritardoUscita = setTimeout(function () { sopraAttivo = null; ridisponi(null); }, 50);
      });
    }

    radice.querySelectorAll('[data-verso]').forEach(function (b) {
      b.addEventListener('click', function () { scorri(b.dataset.verso); });
    });

    radice.querySelectorAll('.arco__mazzo').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-disabled') === 'true') return;
        mazzoId = b.dataset.mazzo;
        radice.querySelectorAll('.arco__mazzo').forEach(function (x) {
          x.setAttribute('aria-pressed', String(x === b));
        });
        costruisci();
      });
    });

    /* Cambio di PALETTE: nessuna animazione, per scelta di Richard. Le carte
       sono le stesse nella stessa posa, cambia solo il file dell'immagine:
       si sostituisce l'indirizzo e non si tocca nient'altro. Ricostruire
       voleva dire rifare l'ingresso, che qui non c'entra niente.
       L'unica eccezione sono le Napoletane sulla palette 3, che hanno una
       carta sola invece di due: li' l'elenco cambia e va ricostruito — ma
       senza ingresso lo stesso. */
    function cambiaPalette() {
      var m = dati.mazzi[mazzoId];
      var nuove = m.carte[paletteId];
      var uguali = nuove && nuove.length === carte.length &&
        nuove.every(function (n, i) { return n === carte[i]; });
      if (!uguali) { costruisci(false); return; }

      /* Perche' non basta cambiare l'indirizzo dell'immagine.
         Assegnando `img.src` il browser scarta subito quella vecchia e lascia
         il posto vuoto finche' non ha decodificato la nuova: e' il lampo che
         si vedeva. Precaricare da solo non bastava, perche' il ponte serviva
         le carte con `cache-control: no-store` e quindi il precaricamento non
         veniva conservato (corretto anche quello).
         Qui pero' non ci si affida alla cache: si costruisce l'immagine nuova,
         la si aspetta DECODIFICATA con decode(), e solo allora si sostituisce
         l'elemento. Un buco non puo' esistere per costruzione.
         Il gettone serve se si preme un'altra palette mentre la prima sta
         ancora caricando: la risposta vecchia arriva dopo e va ignorata. */
      var mio = ++gettonePalette;
      var nuovoRetro = m.retro.indexOf(paletteId) === -1 ? null : immagine(mazzoId, paletteId, 'back');

      var prepara = function (src, classe, testo) {
        var img = new Image();
        img.className = classe;
        img.alt = testo || '';
        img.decoding = 'async';
        img.src = src;
        var pronta = img.decode ? img.decode() : Promise.resolve();
        return pronta.catch(function () {}).then(function () { return img; });
      };

      var lavori = elementi.map(function (el, i) {
        var vecchia = el.querySelector('.arco__faccia--fronte');
        return prepara(immagine(mazzoId, paletteId, nuove[i]),
                       'arco__faccia arco__faccia--fronte',
                       vecchia ? vecchia.alt : '')
          .then(function (img) { return { vecchia: vecchia, nuova: img }; });
      });

      var vecchioRetro = radice.querySelector('.arco__faccia--retro');
      if (vecchioRetro && nuovoRetro) {
        lavori.push(prepara(nuovoRetro, 'arco__faccia arco__faccia--retro', '')
          .then(function (img) { return { vecchia: vecchioRetro, nuova: img }; }));
      }

      Promise.all(lavori).then(function (coppie) {
        if (mio !== gettonePalette) return;   // e' arrivata una scelta piu' recente
        carte = nuove;
        retro = nuovoRetro;
        coppie.forEach(function (c) {
          if (c.vecchia && c.vecchia.parentNode) c.vecchia.replaceWith(c.nuova);
        });
      });
    }

    radice.querySelectorAll('.arco__palette').forEach(function (b) {
      b.addEventListener('click', function () {
        if (paletteId === b.dataset.palette) return;
        paletteId = b.dataset.palette;
        radice.querySelectorAll('.arco__palette').forEach(function (x) {
          x.setAttribute('aria-pressed', String(x === b));
        });
        cambiaPalette();
        annuncia();
      });
    });

    var attesa = null;
    window.addEventListener('resize', function () {
      clearTimeout(attesa);
      attesa = setTimeout(function () { misura(); ridisponi(sopraAttivo); }, 120);
    });

    /* La palette scelta qui vale per tutta la pagina: "Scegli il tuo mazzo"
       piu' sotto ci si accoda. Si annuncia e basta — l'arco non sa chi ascolta. */
    function annuncia() {
      document.dispatchEvent(new CustomEvent('mismazzo:palette', {
        detail: { palette: paletteId }
      }));
    }

    costruisci();
    annuncia();
  }

  function tutti() {
    document.querySelectorAll('[data-arco]').forEach(function (r) {
      if (!r.dataset.arcoAvviato) { r.dataset.arcoAvviato = '1'; avvia(r); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tutti);
  else tutti();
  /* l'editor del tema ricarica le sezioni senza ricaricare la pagina */
  document.addEventListener('shopify:section:load', tutti);
})();
